var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqaversantWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    height: 245,
    viewBox: "0 0 1600 245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-agaversant-white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 245
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "agaversant-white",
    clipPath: "url(#clip-agaversant-white)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12400",
    "data-name": "Group 12400",
    transform: "translate(-464.621 -641.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12833",
    "data-name": "Path 12833",
    d: "M1326.875,758.875q-44.082-2.88-44.082-24.976,0-15.476,13.876-23.481a41.97,41.97,0,0,1,12.168-4.591,48.334,48.334,0,0,1,11.313-1.387A40.884,40.884,0,0,1,1351,717.568a36.823,36.823,0,0,1,5.976,7.418q1.922,3.362,3.309,6.352l15.584-5.871q-1.922-4.268-3.2-6.511a71.11,71.11,0,0,0-9.5-12.915q-17.291-18.252-43.015-18.252-21.774,0-37.036,11.74-16.974,12.917-16.972,34.37,0,15.9,11.313,26.044,14.943,13.342,48.245,15.582,19.854,1.28,28.819,11.741a20.474,20.474,0,0,1,5.123,15.371q-1.28,16.545-16.223,23.375A42.714,42.714,0,0,1,1332,829.321a32.2,32.2,0,0,1-3.842.534q-1.6.108-3.842.108a50.793,50.793,0,0,1-25.51-6.3,35.625,35.625,0,0,1-17.4-21.775l-16.012,4.7a51.668,51.668,0,0,0,24.551,31.061,66.743,66.743,0,0,0,34.261,8.965h.214q19.852,0,34.048-10.247,16.116-11.633,17.825-32.448a36.388,36.388,0,0,0-9.179-27.539Q1353.558,760.69,1326.875,758.875Z",
    transform: "translate(149.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12393",
    "data-name": "Group 12393",
    transform: "translate(957.404 690.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12834",
    "data-name": "Path 12834",
    d: "M941.895,791.222,901.171,690.378H883.026l49.779,123.271Z",
    transform: "translate(-883.026 -690.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12835",
    "data-name": "Path 12835",
    d: "M982.533,690.378,937.275,801.646l-9.09,22.427,9.2,22.78,63.3-156.475Z",
    transform: "translate(-874.196 -690.378)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12394",
    "data-name": "Group 12394",
    transform: "translate(1558.988 690.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12836",
    "data-name": "Path 12836",
    d: "M1450.447,717.411l-9.038,22.3,39.789,98.443h18.051Z",
    transform: "translate(-1375.434 -684.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12837",
    "data-name": "Path 12837",
    d: "M1434.006,769.09l13.962-34.545.019.048,9.038-22.3-8.894-22-61.907,153.166h17.641Z",
    transform: "translate(-1386.224 -690.289)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12395",
    "data-name": "Group 12395",
    transform: "translate(1121.01 690.884)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35560",
    "data-name": "Rectangle 35560",
    width: 91.259,
    height: 16.795,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12838",
    "data-name": "Path 12838",
    d: "M1036.74,770.888h59.986V754.024H1036.74V710.965h-16.864V839.413h91.259V822.549H1036.74Z",
    transform: "translate(-1019.875 -686.353)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12396",
    "data-name": "Group 12396",
    transform: "translate(1721.349 687.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12839",
    "data-name": "Path 12839",
    d: "M1648.727,847.184V690.867h-16.864V804.755L1522.031,687.878v24.6Z",
    transform: "translate(-1522.031 -687.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12840",
    "data-name": "Path 12840",
    d: "M1522.031,718V838.037H1538.9V735.932Z",
    transform: "translate(-1522.031 -681.988)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12397",
    "data-name": "Group 12397",
    transform: "translate(1886.125 690.884)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35561",
    "data-name": "Rectangle 35561",
    width: 125.949,
    height: 16.795,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35562",
    "data-name": "Rectangle 35562",
    width: 16.864,
    height: 128.448,
    transform: "translate(54.863 24.612)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12841",
    "data-name": "Path 12841",
    d: "M1230.64,782.171a53.8,53.8,0,0,0-38-91.793h-53.9v153.06H1155.6V797.969h.026V781.1h-.026V707.242h37.037a36.931,36.931,0,0,1,0,73.862h-30.5v16.865h30.5a54.382,54.382,0,0,0,16.4-2.436L1227.811,843h18.146L1223.4,788.32A58.043,58.043,0,0,0,1230.64,782.171Z",
    transform: "translate(124.375 0.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12398",
    "data-name": "Group 12398",
    transform: "translate(830.496 690.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12842",
    "data-name": "Path 12842",
    d: "M841.1,717.411l-9.038,22.3,39.789,98.443H889.9Z",
    transform: "translate(-766.083 -684.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12843",
    "data-name": "Path 12843",
    d: "M824.655,769.09l13.962-34.545.019.048,9.038-22.3-8.894-22L776.873,843.455h17.641Z",
    transform: "translate(-776.873 -690.289)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12399",
    "data-name": "Group 12399",
    transform: "translate(502.621 690.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12844",
    "data-name": "Path 12844",
    d: "M566.844,717.411l-9.038,22.3,39.789,98.443h18.05Z",
    transform: "translate(-491.831 -684.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12845",
    "data-name": "Path 12845",
    d: "M550.4,769.09l13.962-34.545.019.048,9.038-22.3-8.894-22L502.621,843.455h17.641Z",
    transform: "translate(-502.621 -690.289)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12846",
    "data-name": "Path 12846",
    d: "M744.221,761.275h-18.05l33.4,82.632h18.051l-13.6-33.641a76.718,76.718,0,0,0,10.927-24.128,78.688,78.688,0,0,0,0-39.427,78.823,78.823,0,0,0-25.762-40.534l.007-.012c-.243-.2-.5-.4-.74-.6-.16-.129-.318-.262-.479-.391-.433-.355-.857-.716-1.3-1.06A77.625,77.625,0,0,0,728.548,693.8l-.147-.057c-.966-.387-1.937-.763-2.922-1.112-.647-.233-1.3-.447-1.955-.662-.442-.145-.881-.3-1.328-.433-1.027-.318-2.063-.61-3.1-.886-.124-.032-.245-.073-.369-.105-.042-.011-.084-.018-.126-.029-1-.258-2.016-.491-3.032-.709-.325-.072-.652-.149-.977-.216-.593-.12-1.193-.221-1.791-.328-2.072-.375-4.146-.681-6.22-.891-.21-.022-.421-.031-.631-.051-1.049-.1-2.1-.183-3.147-.237-.512-.027-1.023-.031-1.535-.048-.756-.024-1.51-.054-2.267-.055-.674,0-1.349.023-2.023.039-.615.014-1.228.019-1.842.049-.638.031-1.276.086-1.913.133-.685.05-1.371.093-2.056.161-.389.038-.777.094-1.166.14-.8.091-1.6.171-2.4.287-.165.025-.326.061-.49.086-.118.019-.236.044-.354.063-1.078.176-2.152.365-3.217.582-.75.153-1.5.334-2.248.508-.436.1-.875.195-1.309.3-.208.053-.416.092-.623.146a76.95,76.95,0,0,0-28.028,13.691c-.481.367-.94.754-1.41,1.131l-.024.019q-1.357,1.087-2.659,2.227c-.158.137-.313.277-.47.416q-1.065.949-2.093,1.932c-.314.3-.623.6-.931.909-.5.493-.989.99-1.47,1.5-.522.544-1.035,1.1-1.543,1.659-.222.249-.447.5-.667.747-1.148,1.3-2.272,2.625-3.343,4.01a78.32,78.32,0,0,0,0,95.407c1.071,1.384,2.195,2.711,3.344,4.011.219.251.442.5.665.744q.762.843,1.546,1.663c.481.506.972,1,1.468,1.493.308.3.619.611.934.911q1.024.983,2.09,1.93l.473.418q1.3,1.141,2.658,2.226l.024.019c.47.377.929.764,1.41,1.131a76.951,76.951,0,0,0,28.028,13.691c.208.054.416.093.624.146.432.11.869.2,1.3.3.751.176,1.5.356,2.254.509,1.059.218,2.129.405,3.2.581.123.019.245.045.368.065.164.026.324.061.489.086.8.116,1.6.2,2.395.287.39.045.778.1,1.168.141.687.068,1.374.11,2.06.16.636.047,1.272.1,1.908.133.618.03,1.235.035,1.853.05.671.016,1.341.041,2.012.038.758,0,1.516-.031,2.273-.055.51-.017,1.02-.02,1.53-.048,1.052-.054,2.1-.141,3.155-.238.207-.019.414-.029.622-.05,2.075-.208,4.148-.514,6.221-.891.6-.106,1.2-.208,1.791-.328.325-.067.652-.145.977-.215,1.016-.219,2.029-.451,3.032-.709.042-.012.084-.019.126-.03.125-.032.246-.073.371-.105,1.041-.276,2.077-.568,3.1-.886.447-.137.886-.288,1.328-.433.654-.215,1.308-.429,1.955-.662.985-.349,1.956-.725,2.922-1.112.048-.019.1-.037.147-.057a77.641,77.641,0,0,0,16.884-9.393l-6.418-15.79a67.248,67.248,0,0,1-8.638,6.016q-2.893,1.7-5.832,3.063a66.109,66.109,0,0,1-9.95,3.444,63.843,63.843,0,0,1-17.684,2.111,65.131,65.131,0,0,1-13.426-2.048,68.121,68.121,0,0,1-7.6-2.464,67.133,67.133,0,0,1-8.279-4.144,58.048,58.048,0,0,1-22.01-21.946,66.924,66.924,0,0,1-4.806-9.95q-1.042-2.894-1.84-5.972a64.216,64.216,0,0,1-2.1-14.992c0-.185-.008-.371-.007-.557s.006-.371.007-.557a64.216,64.216,0,0,1,2.1-14.992q.8-3.077,1.84-5.972a66.924,66.924,0,0,1,4.806-9.95,58.024,58.024,0,0,1,22.01-21.946,67.329,67.329,0,0,1,8.28-4.145,68.347,68.347,0,0,1,7.6-2.463,65.11,65.11,0,0,1,13.423-2.048,63.855,63.855,0,0,1,17.687,2.111,66.245,66.245,0,0,1,9.95,3.444q2.939,1.368,5.832,3.063,19.056,11.21,26.487,31.039l-.018.031c.21.524.4,1.05.6,1.576.587,1.7,1.125,3.432,1.589,5.221a58.882,58.882,0,0,1,0,31.174c-.464,1.789-1,3.523-1.589,5.222-.195.525-.387,1.051-.6,1.575l.018.032c-.237.63-.494,1.245-.748,1.861Z",
    transform: "translate(23.054 0.038)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaversantWhite);
export default __webpack_public_path__ + "static/media/aqaversant-white.2d46332c77940ac1840206c601364ae8.svg";
export { ForwardRef as ReactComponent };